module.exports = __webpack_public_path__ + "./MileyPhoto_43f649b115d7c329424e6f0e1869dcfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/MileyPhoto.png
// module id = 539
// module chunks = 0